module.exports = __webpack_public_path__ + "img/web-p2-f2.ec6e37c5.svg";